/**
 * v-can="'driver.archive'" — hide the element when the user lacks the
 * permission. As with usePermission, this is *cosmetic only*: the server still
 * enforces RBAC for every action call.
 *
 * Supports:
 *   v-can="'driver.archive'"           — single permission
 *   v-can="['driver.archive','admin']" — array → OR
 */
import type { Directive, DirectiveBinding } from 'vue';
import { useAuthStore } from '@/stores/auth.store';

type CanBinding = string | string[];

function allowed(binding: DirectiveBinding<CanBinding>): boolean {
  const auth = useAuthStore();
  const v = binding.value;
  if (!v) return false;
  if (Array.isArray(v)) return v.some((p) => auth.permissions.has(p));
  return auth.permissions.has(v);
}

export const vCan: Directive<HTMLElement, CanBinding> = {
  mounted(el, binding) {
    if (!allowed(binding)) {
      el.dataset.canHidden = 'true';
      el.style.display = 'none';
    }
  },
  updated(el, binding) {
    if (allowed(binding)) {
      if (el.dataset.canHidden === 'true') {
        el.style.display = '';
        delete el.dataset.canHidden;
      }
    } else {
      el.dataset.canHidden = 'true';
      el.style.display = 'none';
    }
  },
};
